import {useMemo} from "react";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import {IRRIGATIONS} from "../utils/enumItemsUtils";
import {Irrigation} from "../types/domain/irrigation";

export const useIrrigations = () => {
    const {t} = useTranslation();

    return useMemo(() => {
        const irrigations: Irrigation[] = IRRIGATIONS.map((item) => ({
            id: item.id,
            name: t(`enumerations.irrigation_types.${item.i18nKey}`),
        }));

        return {
            irrigations,
            irrigationsById: _.keyBy(irrigations, "id"),
        };
    }, [t]);
};
